"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _tableContext = require("../../Context/tableContext");
var _classnames = _interopRequireDefault(require("classnames"));
var _Helpers = require("../../Helpers");
var _RenderInput = _interopRequireWildcard(require("./RenderInput"));
var _RowSelection = _interopRequireDefault(require("./RowSelection"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TestEditableCell = exports.default = /*#__PURE__*/function (_React$PureComponent) {
  function TestEditableCell(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TestEditableCell);
    _this = _callSuper(this, TestEditableCell, [props]);
    _this.setFocusedHighlight = _this.setFocusedHighlight.bind(_this);
    _this.setIsEditing = _this.setIsEditing.bind(_this);
    _this.setLocale = _this.setLocale.bind(_this);
    _this.updateRow = _this.updateRow.bind(_this);
    _this.setInnerValue = _this.setInnerValue.bind(_this);
    _this.setExpandable = _this.setExpandable.bind(_this);
    _this.handleClickEditableCellButton = _this.handleClickEditableCellButton.bind(_this);
    _this.editOnFocus = _this.editOnFocus.bind(_this);
    var row = props.row,
      columnDef = props.columnDef,
      rowKey = props.rowKey;
    _this.state = {
      isEditing: false,
      rowSelection: _tableContext.eventHub.getState('rowSelection'),
      innerValue: row[columnDef.dataIndex],
      locale: _tableContext.eventHub.getState('locale'),
      focusedHighlight: _tableContext.eventHub.getState('focusedHighlight'),
      expandable: _tableContext.eventHub.getState('expandable'),
      isDisabled: checkDisable(columnDef, row)
    };
    var cellEditingId = rowKey + '_' + columnDef.dataIndex;
    _this.indexClass = row.key.replace(/[.]/g, '-');
    _this.unsubscriber = [_tableContext.eventHub.on('update.focusedHighlight', _this.setFocusedHighlight), _tableContext.eventHub.on("isEditing.".concat(cellEditingId), _this.setIsEditing), _tableContext.eventHub.on('update.locale', _this.setLocale), _tableContext.eventHub.on('update.expandable', _this.setLocale), _tableContext.eventHub.on("update.row.".concat(rowKey), _this.updateRow), _tableContext.eventHub.on("forceUpdate.".concat(rowKey), function () {
      _this.forceUpdate();
    })];
    return _this;
  }
  (0, _inherits2.default)(TestEditableCell, _React$PureComponent);
  return (0, _createClass2.default)(TestEditableCell, [{
    key: "setExpandable",
    value: function setExpandable(params) {
      this.setState({
        expandable: params
      });
    }
  }, {
    key: "updateRow",
    value: function updateRow(updatedRow) {
      var columnDef = this.props.columnDef;
      this.setState({
        isDisabled: checkDisable(columnDef, updatedRow)
      });
      this.setInnerValue(updatedRow[columnDef.dataIndex]);
      var childrenListedGroups = _tableContext.eventHub.getState('childrenListedGroups') || [];
      if (childrenListedGroups.includes(columnDef.dataIndex)) {
        this.forceUpdate();
      }
    }
  }, {
    key: "setInnerValue",
    value: function setInnerValue(value) {
      this.setState({
        innerValue: value
      });
    }
  }, {
    key: "setFocusedHighlight",
    value: function setFocusedHighlight(value) {
      this.setState({
        focusedHighlight: value
      });
    }
  }, {
    key: "setIsEditing",
    value: function setIsEditing(value) {
      this.setState({
        isEditing: value
      });
    }
  }, {
    key: "setLocale",
    value: function setLocale(value) {
      this.setState({
        locale: value
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      var columnDef = newProps.columnDef,
        row = newProps.row;
      this.setInnerValue(row[columnDef.dataIndex]);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscriber.forEach(function (fn) {
        return fn();
      });
    }
  }, {
    key: "handleClickEditableCellButton",
    value: function handleClickEditableCellButton() {
      var _this$props = this.props,
        columnDef = _this$props.columnDef,
        row = _this$props.row,
        rowKey = _this$props.rowKey;
      var isDisabled = this.state.isDisabled;
      var validationHasError = _tableContext.eventHub.getState('validationHasError');
      try {
        if (columnDef.editable && !validationHasError.current && !isDisabled) {
          _tableContext.eventHub.emit('setEditingKey&selectedDataIndex', rowKey, columnDef.dataIndex);
          // input onblur'unda eğer bir önceki editable cell hata alırsa yeni tıklanan hücre
          // edit moda geçmemeli. Mevcut input'un focus'u devam etmeli.
        }
      } catch (err) {
        console.info('DefaultEditableCell handleClickEditableCellButton does not updates dataIndex and key unless validation completed', err);
      }
    }
  }, {
    key: "editOnFocus",
    value: function editOnFocus() {
      var _this$props2 = this.props,
        columnDef = _this$props2.columnDef,
        row = _this$props2.row,
        rowKey = _this$props2.rowKey;
      var isDisabled = this.state.isDisabled;
      var validationHasError = _tableContext.eventHub.getState('validationHasError');
      if (columnDef.editable && !validationHasError.current && !isDisabled) {
        // Tab yapıldıgında sonradan data setlemesi gormesin diye data setleme işleminden sonrasında düşmesi için (tablo refresinden sonra)
        // settimeout ile button focus işlemi, data setlemesinin arkasına almak için eklendi.

        if (!!_tableContext.eventHub.getState('editOnFocus') && !validationHasError.current) {
          _tableContext.eventHub.emit('setEditingKey&selectedDataIndex', rowKey, columnDef.dataIndex);
        }

        // hata olup olmaksizin tab ile focus atması için if dışında bırakıldı.
        _tableContext.eventHub.emit('update.submitingElementClassName', "editable-cell-".concat(this.indexClass, "-").concat(columnDef.dataIndex));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _columnDef$fixed;
      var _this$props3 = this.props,
        columnDef = _this$props3.columnDef,
        rowIndex = _this$props3.rowIndex,
        isExpanded = _this$props3.isExpanded,
        showChildForFilter = _this$props3.showChildForFilter,
        row = _this$props3.row,
        prefixCls = _this$props3.prefixCls,
        cellIndex = _this$props3.cellIndex,
        hasChildren = _this$props3.hasChildren,
        id = _this$props3.id,
        isActiveFilter = _this$props3.isActiveFilter,
        isFiltered = _this$props3.isFiltered,
        rowKey = _this$props3.rowKey,
        depth = _this$props3.depth;
      var _this$state = this.state,
        focusedHighlight = _this$state.focusedHighlight,
        isEditing = _this$state.isEditing,
        rowSelection = _this$state.rowSelection,
        innerValue = _this$state.innerValue,
        locale = _this$state.locale,
        expandable = _this$state.expandable,
        isDisabled = _this$state.isDisabled;
      var isCellEditingCheck = focusedHighlight && isEditing;
      var isExpandedColumn = !(expandable !== null && expandable !== void 0 && expandable.expandedRowRender) && !(expandable !== null && expandable !== void 0 && expandable.expandIconColumnIndex) || columnDef.dataIndex === 'expandedColumn';
      var isFixedColumn = (_columnDef$fixed = columnDef.fixed) !== null && _columnDef$fixed !== void 0 ? _columnDef$fixed : false;
      var marginLeft = 20 * depth;
      var fixedKey = (columnDef === null || columnDef === void 0 ? void 0 : columnDef.fixed) || 'left';
      var className = "".concat(prefixCls, "-cell row-").concat(row.index, "-cell-").concat(cellIndex, " ").concat(isFixedColumn ? 'sticky-cell' : '', " ").concat(fixedKey);
      var expandIconColumnIndex = expandable !== null && expandable !== void 0 && expandable.expandIconColumnIndex || !!rowSelection ? 1 : 0;
      var cellStyleCls = typeof columnDef.cellStyle == 'function' ? columnDef.cellStyle(_objectSpread(_objectSpread({}, row), {}, (0, _defineProperty2.default)({}, columnDef.dataIndex, innerValue)), row.index) : columnDef.cellStyle || '';
      if (!hasChildren || cellIndex !== expandIconColumnIndex) {
        marginLeft += 10;
      }
      var render = _Helpers.Utils.getDefaultColumnRender(locale, columnDef);
      var childOrValue = innerValue !== null && innerValue !== void 0 ? innerValue : '';
      if (typeof render == 'function') {
        childOrValue = render(innerValue, row) || '';
      }
      var preparedClassName = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, className, true), cellStyleCls, true), 'row-selection', (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection'), "customError", cellStyleCls && cellStyleCls.indexOf('custom-error') > -1 || cellStyleCls.indexOf('customError') > -1), 'position-sticky', isFixedColumn), 'position-relative', !isFixedColumn), "disabled", isDisabled), "focused", isCellEditingCheck), "table-column-".concat(columnDef.dataIndex), true), 'editable-table-cell', columnDef.editable));
      var wrapperStyle = {
        display: cellIndex === expandIconColumnIndex ? 'flex' : null,
        width: cellIndex === expandIconColumnIndex ? columnDef.size - marginLeft : null,
        marginLeft: cellIndex === expandIconColumnIndex ? marginLeft : null,
        // display: "flex",
        alignItems: 'center',
        justifyContent: 'flex-start'
      };
      var useCustomBorder = true;
      var editableButtonClassname = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        'editable-cell-button ': columnDef.editable
      }, "editable-cell-".concat(this.indexClass, "-").concat(columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex), true), "disabled", isDisabled), "display", (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection' ? 'none' : 'block'), columnDef === null || columnDef === void 0 ? void 0 : columnDef.type, true));
      return /*#__PURE__*/_react.default.createElement("td", {
        key: "td-".concat(id),
        className: preparedClassName,
        onClick: this.handleClickEditableCellButton
      }, useCustomBorder && !isCellEditingCheck && (cellStyleCls && cellStyleCls.indexOf('custom-error') > -1 || cellStyleCls.indexOf('customError') > -1) && /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-border"
      }), (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection' && /*#__PURE__*/_react.default.createElement(RenderRowSelection, {
        isRowSelectionColumn: (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection',
        prefixCls: prefixCls,
        rowSelection: rowSelection,
        isActiveFilter: isActiveFilter,
        isFiltered: isFiltered,
        isDisabled: isDisabled,
        rowKey: rowKey,
        row: row,
        showChildForFilter: showChildForFilter
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell-container-wrapper",
        style: wrapperStyle
      }, /*#__PURE__*/_react.default.createElement(_RenderInput.RenderExpandIcon, {
        isExpandedColumn: isExpandedColumn,
        expandable: expandable,
        hasChildren: hasChildren,
        cellIndex: cellIndex,
        expandIconColumnIndex: expandIconColumnIndex,
        prefixCls: prefixCls,
        record: row,
        rowKey: rowKey,
        rowIndex: rowIndex,
        isExpanded: isExpanded,
        isActiveFilter: isActiveFilter
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell-wrapper",
        style: {
          width: cellIndex === expandIconColumnIndex ? columnDef.size - marginLeft : columnDef.size
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: editableButtonClassname,
        tabIndex: isDisabled ? '-1' : '0',
        type: "ghost",
        onFocus: this.editOnFocus
      }, /*#__PURE__*/_react.default.createElement(_RenderInput.default, {
        key: "".concat(id, "-renderInput"),
        row: {
          original: row,
          id: row.key,
          index: row.index
        },
        column: {
          dataIndex: columnDef.dataIndex,
          cellChangeTrigger: columnDef.cellChangeTrigger,
          editable: columnDef.editable,
          inputProps: columnDef.inputProps
        },
        undoText: locale === null || locale === void 0 ? void 0 : locale.undo,
        isDisabled: isDisabled,
        rowKey: rowKey,
        isEditing: isEditing,
        setInnerValue: this.setInnerValue
      }, childOrValue)))));
    }
  }]);
}(_react.default.PureComponent);
function checkDisable(columnDef, row) {
  var isDisabled = false;
  if (columnDef !== null && columnDef !== void 0 && columnDef.disabled) {
    if (typeof (columnDef === null || columnDef === void 0 ? void 0 : columnDef.disabled) === 'function') {
      isDisabled = columnDef === null || columnDef === void 0 ? void 0 : columnDef.disabled(row, row.index);
    } else {
      isDisabled = true;
    }
  }
  return isDisabled;
}
var RenderRowSelection = /*#__PURE__*/function (_React$PureComponent2) {
  function RenderRowSelection(props) {
    var _this2;
    (0, _classCallCheck2.default)(this, RenderRowSelection);
    _this2 = _callSuper(this, RenderRowSelection, [props]);
    _this2.changeEditMode = _this2.changeEditMode.bind(_this2);
    _this2.state = {
      editMode: false
    };
    _this2.unsubscriber = [_tableContext.eventHub.on('update.editMode', _this2.changeEditMode)];
    return _this2;
  }
  (0, _inherits2.default)(RenderRowSelection, _React$PureComponent2);
  return (0, _createClass2.default)(RenderRowSelection, [{
    key: "changeEditMode",
    value: function changeEditMode(status) {
      this.setState({
        editMode: status
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscriber.forEach(function (fn) {
        return fn();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        isRowSelectionColumn = _this$props4.isRowSelectionColumn,
        isActiveFilter = _this$props4.isActiveFilter,
        showChildForFilter = _this$props4.showChildForFilter,
        isFiltered = _this$props4.isFiltered,
        rowKey = _this$props4.rowKey,
        row = _this$props4.row;
      if (!isRowSelectionColumn) {
        return null;
      }
      var _rowSelection = _tableContext.eventHub.getState('rowSelection');
      var _filters = _tableContext.eventHub.getState('clientFilters');
      var selectionProps = typeof (_rowSelection === null || _rowSelection === void 0 ? void 0 : _rowSelection.getCheckboxProps) === 'function' ? _rowSelection.getCheckboxProps(_objectSpread(_objectSpread({}, row), {}, {
        isActiveFilter: isActiveFilter && !showChildForFilter
      }), _filters) : {};
      return /*#__PURE__*/_react.default.createElement(_RowSelection.default, (0, _extends2.default)({
        rowKey: rowKey,
        isFiltered: isFiltered
      }, selectionProps));
    }
  }]);
}(_react.default.PureComponent);